import React from "react";
import History from "../../utilities/History";
import Landing from "./Landing";
import * as CONSTANTS from "../../utilities/Constants";
import "./backup.sass";
import SidebarLayout from "../shared/SidebarLayout";
import SidebarList from "../shared/SidebarList";
import SidebarTitle from "../shared/SidebarTitle";
import backupAndRestoreListStore from "../../flux/stores/backupAndRestore/listStore";
import NoDataOnboarding from "../shared/NoDataOnboarding";
import { Translation } from "react-i18next";
import IActionHeaderFormData from "../../models/shared/ActionHeaderData";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";

interface IBackupLandingState {
  isFullSidebarVisible: boolean;
  backupPrefix: string;
  prefixError: boolean;
  buttonDisabled: boolean;
}

export default class Index extends React.Component<
  { location: any },
  IBackupLandingState
> {
  private _mount = false;
  private _isReload = true;
  private _messages: string[];
  private _id = "";
  private _isValid: boolean = false;

  constructor(props: { location: any }) {
    super(props);
    this._mount = false;
    this.state = {
      isFullSidebarVisible: true,
      backupPrefix: CONSTANTS.LMS_BACKUP_PREFIX,
      prefixError: false,
      buttonDisabled: false,
    };

    if (
      this.props.location.state &&
      this.props.location.state.isReloadFirst !== undefined
    ) {
      this._isReload = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;

      const state = { ...this.props.location.state };
      delete state.isReloadFirst;
      delete state.id;
      History.replace({ ...History.location, state });
    }
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
    const addRequest = {
      moduleName: CONSTANTS.MODULE_SETTINGS,
      createData: {},
    } as IActionHeaderFormData;
    actionHeaderActions.common(addRequest).then();
  }

  public setBackupPrefix = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      this.setState({ prefixError: false, backupPrefix: val }, this.validate);
    } else {
      this.setState(
        { prefixError: value === "" ? false : true, backupPrefix: val },
        this.validate
      );
    }
  };

  validate(): void {
    if (
      !this.state.prefixError &&
      this.state.backupPrefix?.trim() &&
      this.state.backupPrefix !== ""
    ) {
      this._isValid = true;
      this.setState({
        buttonDisabled: false,
      });
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true,
      });
    }
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
            <React.Fragment>
              <SidebarLayout
                isFullSidebarVisible={this.state.isFullSidebarVisible}
                handlePanelToggle={() =>
                  this.setState({
                    isFullSidebarVisible: !this.state.isFullSidebarVisible,
                  })
                }
                isShowSelectFilter={false}
                selectedSource={[]}
                trendDropdownSourceList={[]}
              >
                <SidebarTitle title={t(CONSTANTS.MODULE_BACKUP_AND_RESTORE)} />
                <SidebarList
                  setBackupPrefix={(val: string) => this.setBackupPrefix(val)}
                  backupPrefix={this.state.backupPrefix}
                  prefixError={this.state.prefixError}
                  onSelectLink={null}
                  listData={[]}
                  activeId={null}
                  isShowBackup={true}
                  isAutoBackup={true}
                />
              </SidebarLayout>
              <div
                className={
                  this.state.isFullSidebarVisible
                    ? "main-layout ml-3 no-padding main-layout-trends"
                    : "main-full-layout float-right main-full-layout-trends"
                }
              >
                <Landing
                  backupPrefix={this.state.backupPrefix}
                  isButtonDisabled={this.state.buttonDisabled}
                  clearPrefixInput={(val: string) => this.setBackupPrefix(val)}
                />
              </div>
            </React.Fragment>
          </div>
        )}
      </Translation>
    );
  }
}
